import { OrganizationTraits } from '@neptune/shared/core-organizations-domain';

export const hasModelRegistryLimits = (traits: OrganizationTraits): boolean =>
  !!traits.modelRegistryLimits;
export const getModelsPerProjectLimit = (traits: OrganizationTraits): number | undefined =>
  traits.modelRegistryLimits?.maxModelsPerProject;
export const getModelsPerProjectEffectiveLimit = (traits: OrganizationTraits): number =>
  getModelsPerProjectLimit(traits) ?? Number.POSITIVE_INFINITY;
